module.exports = __webpack_public_path__ + "img/ig_icon.a0d02930.png";